import { render, staticRenderFns } from "./CommandCenter.vue?vue&type=template&id=38281134&scoped=true&"
import script from "./CommandCenter.vue?vue&type=script&lang=js&"
export * from "./CommandCenter.vue?vue&type=script&lang=js&"
import style0 from "./CommandCenter.vue?vue&type=style&index=0&id=38281134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38281134",
  null
  
)

export default component.exports